import React from "react";

import { BoxProps, styled, Box } from "@material-ui/core";

export const TextBox: React.FC<
  { isStruckThrough?: boolean; isGrey?: boolean } & BoxProps
> = ({ isStruckThrough, isGrey, children, ...props }) => {
  const StyledBox = styled(Box)(({ theme }) => ({
    textDecoration: isStruckThrough ? "line-through" : undefined,
    color: isGrey ? theme.palette.text.secondary : theme.palette.text.primary,
    textDecorationColor:
      isStruckThrough && isGrey
        ? theme.palette.text.secondary
        : theme.palette.text.primary,
  }));
  return <StyledBox {...props}>{children}</StyledBox>;
};
